import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getStateList } from "../../redux/actions/indexActions";
const AddDestination = () => {
  const [formData, setFormData] = useState({ state_id: "", city_id: 0, town_id: 0 });
  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  const [towns, setTowns] = useState([]);

  const {
    AuthReducer: { auth },
    indexReducer: { stateLists }
  } = useSelector((state) => state);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(getStateList(auth.token));
  }, [auth]);
  
  const handleSubmit = () => {
    const form = new FormData();
    form.append('state_id', formData.state_id)
    form.append('city_id', formData.city_id)
    form.append('town_id', formData.town_id)
    axios.post(`/api/admin/v1/add-destination`, form, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    }).then((res) => {
      toast.success(res.data?.message);
      navigate(-1);
    }).catch((err) => {
      toast.error(err.response.data);
      setErrors(err.response.data);
    });
  };
  useEffect(() => {
    if (formData.state_id) {
      setFormData((prev) => ({ ...prev, city_id: 0 }));
      axios(`/api/admin/v1/get-city/${formData.state_id}`)
        .then(({ data }) => {
          console.log(data, 'date');
          setCities(data?.data);
        }).catch((err) => console.error(err));
    } else {
      setCities([]);
    }
  }, [formData.state_id]);

  useEffect(() => {
    if (formData.state_id && formData.city_id) {
      setFormData((prev) => ({ ...prev, town_id: "" }));
      axios(`/api/admin/v1/get-town/${formData.state_id}/${formData.city_id}`)
        .then(({ data }) => {
          console.log(data?.data, 'date');
          setTowns(data?.data);
        }).catch((err) => console.error(err));
    } else {
      setTowns([]);
    }
  }, [formData?.state_id, formData?.city_id]);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Destination</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.state_id}
                type="select"
                name="state_id"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                {stateLists?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.state_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.state_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>City </Label>
              <Input value={formData?.city_id} type="select" name="city_id" onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}>
                <option value="">Select</option>
                {cities?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.city_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.city_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Town</Label>
              <Input invalid={Boolean(errors?.town_id)} value={formData?.town_id} type="select" name="town_id" onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}>
                <option value="">Select</option>
                {towns?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.town_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.town_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input type="switch" checked={formData?.status} onChange={inputHandler} name="status" />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDestination;
